import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { TagIcon, XIcon } from 'lucide-react';
import { getCreator } from '../../utils/catalog';
import { formatPrice } from '../../utils/currency';
import type { CheckoutState } from '../../hooks/useCheckout';
export function OrderSummary({
  checkout
}: {
  checkout: CheckoutState;
}) {
  const {
    lines,
    subtotal,
    discount,
    shippingCost,
    shipping,
    total,
    promo,
    applyPromo,
    removePromo
  } = checkout;
  const [code, setCode] = useState('');
  const [promoError, setPromoError] = useState(false);
  const submitPromo = (e: React.FormEvent) => {
    e.preventDefault();
    if (!code.trim()) return;
    const ok = applyPromo(code);
    setPromoError(!ok);
    if (ok) setCode('');
  };
  return <div data-id="element-144" data-mp="31oop2iqk3un8">
      <ul className="space-y-4" data-id="element-145" data-mp="35oqpkokk2i0x">
        {lines.map(l => <li key={l.key} className="flex items-center gap-4" data-id="element-146" data-mp="35qa4obuh6n14">
            <div className="relative h-20 w-16 shrink-0" data-id="element-147" data-mp="3aolggs4bz7lz">
              <img src={l.product.images[0]} alt="" className="h-full w-full rounded-sm object-cover" data-id="element-148" data-mp="2vc5ac8s64m69" />
              <span className="absolute -right-2 -top-2 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-ink px-1 text-[11px] font-semibold text-paper" data-id="element-149" data-mp="2rajrm6syddo5">
                {l.quantity}
              </span>
            </div>
            <div className="min-w-0 flex-1" data-id="element-150" data-mp="2hde0iykc9mnx">
              <p className="truncate text-sm font-medium" data-id="element-151" data-mp="2hep2qty4ymcx">{l.product.name}</p>
              <p className="text-xs text-muted" data-id="element-152" data-mp="3ezkznsxvimsw">
                {getCreator(l.product.creatorId)?.name}
                {l.option ? ` · ${l.option}` : ''}
              </p>
            </div>
            <p className="text-sm tabular-nums" data-id="element-153" data-mp="358qfqv83nzam">{formatPrice(l.product.price * l.quantity)}</p>
          </li>)}
      </ul>

      <div className="mt-6 border-t border-line pt-5" data-id="element-154" data-mp="309dtocp1yw93">
        {promo ? <div className="flex items-center justify-between rounded-md bg-sage/10 px-3 py-2.5 text-sm" data-id="element-155" data-mp="1mj25gu4rdc6">
            <span className="flex items-center gap-2" data-id="element-156" data-mp="3sykslcsf5nuv">
              <TagIcon className="h-4 w-4 text-sage" data-id="element-157" data-mp="1r23hd7xisdao" /> {promo.code} · −{Math.round(promo.rate * 100)} %
            </span>
            <button type="button" onClick={removePromo} aria-label="Retirer le code" className="rounded-full p-1 hover:bg-sage/20" data-id="element-158" data-mp="1v2nh8j9h9v0i">
              <XIcon className="h-4 w-4" data-id="element-159" data-mp="1hapovk3zkdr1" />
            </button>
          </div> : <form onSubmit={submitPromo} noValidate data-id="element-160" data-mp="1m9iruilncmcy">
            <label htmlFor="promo" className="sr-only" data-id="element-161" data-mp="17e32urzxbgnf">
              Code promo
            </label>
            <div className="flex gap-2" data-id="element-162" data-mp="1cdpfaz7xgsv6">
              <input id="promo" value={code} onChange={e => {
            setCode(e.target.value);
            setPromoError(false);
          }} placeholder="Code promo" aria-invalid={promoError || undefined} aria-describedby={promoError ? 'promo-error' : undefined} className={`h-11 min-w-0 flex-1 rounded-md border bg-card px-3 text-sm uppercase outline-none placeholder:normal-case focus:border-ink ${promoError ? 'border-clay' : 'border-line'}`} data-id="element-163" data-mp="1cbcqc23r5i8m" />
              <button type="submit" className="h-11 shrink-0 rounded-md border border-ink/25 px-4 text-sm font-medium transition-colors duration-150 hover:border-ink" data-id="element-164" data-mp="3gmsjo2wau94l">
                Appliquer
              </button>
            </div>
            <AnimatePresence data-id="element-165" data-mp="3qn1f3eigvqix">
              {promoError && <motion.p id="promo-error" initial={{
            opacity: 0,
            y: -4
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.18
          }} className="mt-1.5 text-xs text-clay" data-id="element-166" data-mp="3lllufnk7bm12">
                  Ce code n’est pas valide. Essayez BIENVENUE10.
                </motion.p>}
            </AnimatePresence>
          </form>}
      </div>

      <dl className="mt-5 space-y-2.5 border-t border-line pt-5 text-sm" data-id="element-167" data-mp="22mxqsyavf9kl">
        <div className="flex justify-between" data-id="element-168" data-mp="27lr52sxzf4lt">
          <dt className="text-muted" data-id="element-169" data-mp="27on30h9txta9">Sous-total</dt>
          <dd className="tabular-nums" data-id="element-170" data-mp="2bnvt9c5nv912">{formatPrice(subtotal)}</dd>
        </div>
        {discount > 0 && <div className="flex justify-between text-sage" data-id="element-171" data-mp="2gm5p7oz7mdnq">
            <dt data-id="element-172" data-mp="1jx7x6eiugtu9">Réduction</dt>
            <dd className="tabular-nums" data-id="element-173" data-mp="1jxzhuuawl75r">−{formatPrice(discount)}</dd>
          </div>}
        <div className="flex justify-between" data-id="element-174" data-mp="1nxrvvmj2g5ii">
          <dt className="text-muted" data-id="element-175" data-mp="1nwgrbkhsqtqc">{shipping.label}</dt>
          <dd className="tabular-nums" data-id="element-176" data-mp="1swl718avrkfi">{shippingCost === 0 ? 'Offert' : formatPrice(shippingCost)}</dd>
        </div>
        <div className="flex items-baseline justify-between border-t border-line pt-4" data-id="element-177" data-mp="1xpxjkk2ac0rw">
          <dt className="font-medium" data-id="element-178" data-mp="108790sjsko3y">Total TTC</dt>
          <dd className="font-display text-3xl tabular-nums" data-id="element-179" data-mp="1581yqsrtz7nf">{formatPrice(total)}</dd>
        </div>
      </dl>
    </div>;
}